import { render, staticRenderFns } from "./RandomAlbum.vue?vue&type=template&id=c9dd339e&scoped=true&"
import script from "./RandomAlbum.vue?vue&type=script&lang=js&"
export * from "./RandomAlbum.vue?vue&type=script&lang=js&"
import style0 from "./RandomAlbum.vue?vue&type=style&index=0&id=c9dd339e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dd339e",
  null
  
)

export default component.exports